import type { UserLeadItemProps } from './user-lead-item.types';

export function UserLeadItem({
  title,
  content,
  id: fieldId,
}: UserLeadItemProps) {
  if (!content) {
    return null;
  }

  const labelId = `${fieldId}-label`;

  return (
    <dl className="min-w-[100px]">
      <dt id={labelId} className="hc-typography--help-text inline">
        {title}
      </dt>
      <dd
        aria-labelledby={labelId}
        className="hc-typography--paragraph-sm ml-8-8 inline font-bold"
      >
        {content}
      </dd>
    </dl>
  );
}
